{
  "id": "campaign-042",
  "name": "Misty Paddock",
  "seed": "campaign:42",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "........RRRR",
    "........RRRR",
    "..z.....____",
    "zzz..T......",
    "............",
    "...T........",
    "vvvzzzzzzzzz",
    "vvvzy.....y.",
    "..cc........",
    "...........y",
    "ffffffffff..",
    "............",
    "....#,#.....",
    "....,,......",
    ".....,x....S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 11,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 2,
      "y": 12
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 2,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 11
    }
  ],
  "generatorVersion": 3,
  "level": 42,
  "biome": "farm",
  "par": {
    "reel": 6190,
    "push": 5218,
    "selfPropelled": 4524,
    "tractor": 4250,
    "zeroTurn": 3212,
    "fairway": 1938
  },
  "routeTries": {
    "par": {
      "reel": 16,
      "push": 4,
      "selfPropelled": 11,
      "tractor": 2,
      "zeroTurn": 12,
      "fairway": 8
    }
  }
}
